import { EoCompletionComparison } from '../../@crt/models/mods/eo-completion-comparison.model';

export interface EoCompletionComparisonResponse {
  data: EoCompletionComparison[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}
